const reasons = {
  prizes: { won: 'You took your last prize card.', lost: 'Your opponent took their last prize card.' },
  no_pokemon: { won: 'Your opponent has no Pokémon left in play.', lost: 'You have no Pokémon left in play.' },
  deck_out: { won: 'Your opponent could not draw a card.', lost: 'You could not draw a card.' },
};

/**
 * What the player sees when the game ends, or null while it is still going. Mirrors the server's Game::END_*
 * reasons.
 */
export function outcomeMessage(game, userId) {
  if (!game.get('ended_at')) {
    return null;
  }

  return outcomeFor(game.get('winner_id'), game.get('end_reason'), userId);
}

/** How a game ended, for the player `userId`: who won and why (also the log's game-over line). */
export function outcomeFor(winnerId, endReason, userId) {
  const won = winnerId === userId;
  const reason = reasons[endReason];

  return {
    title: won ? 'You won' : 'You lost',
    detail: reason ? reason[won ? 'won' : 'lost'] : '',
  };
}
